import React from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { LinkToNewTab } from "../../Elements/Link/Link.js";

export const LinksSection = () => {
  const { getTextByKey, getLanguage } = useContent();

  return (
    <div className="footer-links">
      <div className="footer-section-title">{getTextByKey("jumbomail")}</div>
      <LinkToNewTab page="features">{getTextByKey("features")}</LinkToNewTab>

      <LinkToNewTab page="upload-speed-test">
        {getTextByKey("speed-test")}
      </LinkToNewTab>

      <LinkToNewTab page="subscribers">
        {getTextByKey("why-go-pro")}
      </LinkToNewTab>
      <LinkToNewTab page="codes/jumbocode-recovery">
        {getTextByKey("jumbocodes")}
      </LinkToNewTab>
      <LinkToNewTab page="plans">{getTextByKey("plans")}</LinkToNewTab>
      <LinkToNewTab page="support">{getTextByKey("support")}</LinkToNewTab>
      <LinkToNewTab page={`https://status.jumbomail.me/`} fullUrl>
        {getTextByKey("systemstatus")}
      </LinkToNewTab>
      <LinkToNewTab page="news">
        {getTextByKey("news-and-updates")}
      </LinkToNewTab>
      {(getLanguage() === "en" ||
        getLanguage() === "es" ||
        getLanguage() === "it") && (
        <LinkToNewTab page="blog">{getTextByKey("blog")}</LinkToNewTab>
      )}
      <LinkToNewTab page="contact-us">
        {getTextByKey("contact-us")}
      </LinkToNewTab>
      <div className="link-gap" />
      <LinkToNewTab fullUrl page="https://trust.jumbomail.me/">
        {getTextByKey("trust-center")}
      </LinkToNewTab>
    </div>
  );
};
